export default "__VITE_ASSET__06kt1t8F__"